// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mNF0","content":"styles_content__2UKTP"};